import { useSsrAdapter as n } from "../../../../../../@css-render_vue3-ssr@0.15.14_vue@3.5.18/node_modules/@css-render/vue3-ssr/esm/index.js";
import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { cssrAnchorMetaName as c, c as t } from "../../shared/cssr.js";
import { defineComponent as a, h as d } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as i } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const h = t(".v-x-scroll", {
  overflow: "auto",
  scrollbarWidth: "none"
}, [
  t("&::-webkit-scrollbar", {
    width: 0,
    height: 0
  })
]), b = a({
  name: "XScroll",
  props: {
    disabled: Boolean,
    onScroll: Function
  },
  setup() {
    const o = i(null);
    function l(e) {
      !(e.currentTarget.offsetWidth < e.currentTarget.scrollWidth) || e.deltaY === 0 || (e.currentTarget.scrollLeft += e.deltaY + e.deltaX, e.preventDefault());
    }
    const s = n();
    return h.mount({
      id: "vueuc/x-scroll",
      head: !0,
      anchorMetaName: c,
      ssr: s
    }), Object.assign({
      selfRef: o,
      handleWheel: l
    }, {
      scrollTo(...e) {
        var r;
        (r = o.value) === null || r === void 0 || r.scrollTo(...e);
      }
    });
  },
  render() {
    return d("div", {
      ref: "selfRef",
      onScroll: this.onScroll,
      onWheel: this.disabled ? void 0 : this.handleWheel,
      class: "v-x-scroll"
    }, this.$slots);
  }
});
export {
  b as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/x-scroll/src/index.js
// module id = 1791
// module chunks = 67